import type { Theme as ElementalTheme } from '@fortum/elemental-ui'
import { generateLegacyTheme } from '@fortum/elemental-ui'

import type { PreferredComponentSize } from '@/shared/providers/theme'
import type { CosColor } from '@/shared/utils/colors'
import { colors, darkColors, lightColors } from '@/shared/utils/colors'

export type Theme = ElementalTheme & {
  colors: ElementalTheme['colors'] & typeof colors & CosColor
}

const createTheme = (elementalTheme: ElementalTheme, designColors: CosColor): Theme => ({
  ...elementalTheme,
  colors: {
    ...colors,
    ...elementalTheme.colors,
    ...designColors,
  },

  // Override the button styles to fix accessibility issues with the height, where text overflows
  // TODO: Remove this when the Elemental UI is updated to a version that has this fixed:
  button: {
    ...elementalTheme.button,
    web: {
      ...elementalTheme.button.web,
      height: {
        condensed: 'fit-content',
        xs: 'fit-content',
        s: 'fit-content',
        m: 'fit-content',
        l: 'fit-content',
      },
      paddings: {
        ...elementalTheme.button.web.paddings,
        top: 14,
        bottom: 14,
      },
    },
  },
})

export const generateElementalTheme = (
  isDarkMode: boolean,
  preferredSize?: PreferredComponentSize,
): Theme => {
  const elementalTheme = generateLegacyTheme({
    colorScheme: 'modern',
    baseTheme: isDarkMode ? 'dark' : 'light',
  })

  // Set the default component size
  elementalTheme.preferredComponentSize = preferredSize || 's'

  return createTheme(elementalTheme, isDarkMode ? darkColors : lightColors)
}

export const getElementalTheme = (preferredSize?: PreferredComponentSize): Theme =>
  generateElementalTheme(false, preferredSize)
